import { render, staticRenderFns } from "./OrthoKnee.vue?vue&type=template&id=3e9723cc&scoped=true"
import script from "./OrthoKnee.vue?vue&type=script&lang=js"
export * from "./OrthoKnee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9723cc",
  null
  
)

export default component.exports